import React from 'react';

import {
  H1,
  H2,
  Preamble,
  Paragraph,
  Divider,
  Link,
} from '@aurora/widgets-react';

const ServiceLevel = () => (
  <React.Fragment>
    <H1>Service Level</H1>
    <Preamble>
      This page describes when data can be expected to be available and our
      service level in terms of operational availability.
    </Preamble>
    <Paragraph>
      Data available via our webservice (API) is the final step in a chain of
      deliveries. The delivery chain consists of data gathering, model
      calculations, processing and delivering data to the webservice. SMHI has
      continuous surveillance of these processes.
    </Paragraph>
    <H2>Data availability</H2>
    <Paragraph>
      Data of all resolutions (hourly, daily or monthly) will be available via
      the API at 05:00 UTC.
    </Paragraph>
    <H2>System uptime</H2>
    <Paragraph>
      System failure leading to unavailable service is handled by SMHI first
      line support at 06:00-22:00 everyday of the week. Action will be started
      within 1 hour within the service window and a target downtime is set to
      maximum 6 hours.
    </Paragraph>
    <H2>Customer Support</H2>
    <Paragraph>
      Customer support concerning error reports, questions about the web service
      or in general will be addressed at 08:00-16:30 weekdays monday to friday.
      Please post your issues to{' '}
      <Link to="mailto:fastighet@smhi.se">fastighet@smhi.se</Link>
    </Paragraph>

    <Divider />

    <H2>General maintenance</H2>
    <Paragraph>
      Included service consists of:
      <ul>
        <li>Service and surveillance</li>
        <li>
          Configuration and upgrades of operating system, databases and other
          components
        </li>
        <li>Handle of new versions and patches</li>
        <li>Continuous maintenance</li>
        <li>
          Actions upon system errors or other errors leading to unavailable
          service
        </li>
      </ul>
    </Paragraph>
  </React.Fragment>
);

export default ServiceLevel;
